var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SuccessScreen',{attrs:{"titleKey":"ask-visit.success.title","messageKey":"ask-visit.success.message","nextRouteName":"detalle-alojamiento","nextRouteParams":{ idalojamiento: _vm.accommodationId },"buttonTextKey":"ask-visit.success.button-text","backNavigationSteps":3}})
}
var staticRenderFns = []

export { render, staticRenderFns }